import React, { Component } from 'react';
import Axios from 'axios';
import { MDBInput, MDBBtn } from 'mdbreact';
import { API_URL } from '../API_url/API_URL';

class ChangePass extends Component {
    state = {

    }

    changePass = () => {
        let username = this.props.username;
        let password = this.pass.value;
        let newPass = this.Newpass.value;
        let Confirmpass = this.Confirmpass.value;
        console.log(password)
        if(newPass === Confirmpass){
            Axios.get(API_URL+ `/users?username${username}&password=${password}`)
            .then((res) => {
                if(res.data.length === 0){
                    return document.getElementById('alert').innerHTML = "Password has been taken"
                }else if(password === '' || newPass === '' || Confirmpass === ''){
                    return alert("Please fill all forms")
                }else{
                    Axios.patch(API_URL+`/users/${res.data[0].id}`, {
                        password: newPass
                    })
                    .then((res) => {
                        console.log(res.data)
                        document.getElementById('alert').innerHTML = "<br/> Change password successful!"
                    })
                }
            })
            .catch((err) =>{
                console.log(err)
            })
        }

    }



    render() {
        return (
            <div className="d-flex justify-content-center row">
                <div>
                    Password <MDBInput type="password" outline inputRef={(pass) => this.pass = pass} />
                    New Password <MDBInput type="password" outline inputRef={(Newpass) => this.Newpass = Newpass} />
                    Confirm Password <MDBInput type="password" outline inputRef={(Confirmpass) => this.Confirmpass = Confirmpass} />
                    <br/>
                    <MDBBtn color="warning" onClick={this.changePass}>
                        Confirm
                    </MDBBtn>

                    <div id="alert" />
                </div>

            </div>

        )
    }
}

export default (ChangePass)